import { praises } from "@/mocks/baogua";

export default function Voices() {
  return (
    <section id="voice" className="w-full bg-background-50 py-14 md:py-20">
      <div className="mx-auto w-full max-w-7xl px-4 md:px-8">
        <div className="grid grid-cols-1 gap-8 lg:grid-cols-12">
          <div className="lg:col-span-4">
            <span className="inline-flex items-center gap-2 rounded-full bg-secondary-100 px-3 py-1 text-xs font-semibold text-secondary-800">
              <i className="ri-heart-fill"></i> 吃瓜口碑
            </span>
            <h2 className="mt-3 text-2xl md:text-4xl font-bold text-foreground-950">
              百万吃瓜人<br />正在这里<span className="font-display text-primary-500">上瘾围观</span>
            </h2>
            <p className="mt-3 text-sm leading-relaxed text-foreground-600 md:text-base">
              无论是深夜的突发热搜，还是综艺里的高能名场面，爆瓜台总能让你第一时间赶到现场，
              和百万同好一起把瓜吃得明明白白。
            </p>
            <div className="mt-5 flex flex-wrap gap-2">
              {["追星族", "综艺控", "剧集迷", "音乐发烧友"].map((t) => (
                <span key={t} className="whitespace-nowrap rounded-full bg-background-200/70 px-3 py-1.5 text-xs font-medium text-foreground-700">{t}</span>
              ))}
            </div>
          </div>

          <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:col-span-8">
            {praises.map((p) => (
              <figure key={p.name} className="flex flex-col rounded-2xl bg-background-100 p-5 transition hover:bg-background-200/50 md:p-6">
                <div className="flex items-center gap-1 text-accent-500">
                  {Array.from({ length: p.star }).map((_, i) => <i key={i} className="ri-star-fill text-base"></i>)}
                </div>
                <blockquote className="mt-3 flex-1 text-sm leading-relaxed text-foreground-800">
                  “{p.text}”
                </blockquote>
                <figcaption className="mt-4 flex items-center gap-3 border-t border-background-200/70 pt-4">
                  <span className="flex h-10 w-10 items-center justify-center rounded-full bg-gradient-to-br from-primary-400 to-accent-500 text-sm font-bold text-background-50">
                    {p.name.slice(0, 1)}
                  </span>
                  <span>
                    <span className="block text-sm font-semibold text-foreground-950">{p.name}</span>
                    <span className="block text-xs text-foreground-500">{p.role}</span>
                  </span>
                </figcaption>
              </figure>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}